export default __webpack_public_path__ + "static/media/lead-3.2a06616f.png";